module.exports = __webpack_public_path__ + "img/volume-low.98a32f77.svg";